<div class="comp-container" [class.gap]="(items().length % 2) == 0">
  <div class="table-container" [class.bordered]="showBorder" [class.hide]="itemsToShow().length == 0"
    [class.has-header]="showHeader"
    [style]=" columnsSizes == null ? (columns | generateGridTemplate) : 'grid-template-columns: ' + columnsSizes.join(' ') ">
    <div class="row header contents" *ngIf="showHeader">
      <div *ngFor="let column of columns" [class.data]="tableDesign" [class.add]="column.columnAction === 'add'"
        class="cell">
        <div class="cell-content">
          <ng-container *ngIf="(column.columnAction ?? 'none') == 'none'">
            {{ column.name }}
          </ng-container>
          <button *ngIf="column.columnAction === 'add'" [disabled]="disabledBtnAction"
            class="action col-action {{typeToCssClassMap['add']}}">
            <mat-icon [class.disabled]="disabledBtnAction" class="btn btn--col"
              (click)="_columnAction(column.key)">add_circle</mat-icon>
            <div class="icon-background"></div>
          </button>
        </div>
      </div>
    </div>

    <div class="body-container contents" [class.body-container-header]="showHeader" [class.scrollbar]="showHeader"
      id="style-1" #bodyContainer>

      <div class="rows contents" [class.fill-empty-rows]="fillEmptyRows && itemsToShow().length < 0">

        <div *ngFor="let item of itemsToShow(); let i = index" class="row body scrollbar contents" id="style-1"
          [class.white-row]="(i % 2) == 0" (click)="onRowClick(item , i)">
          <div *ngFor="let column of columns" [class.data]="tableDesign" class="cell" [class.odd-row-cel]="(i % 2) == 1"
            [class.btn]="column.type == 'btns'" [style.grid-row]="'span '   ">

            <div *ngIf="column.type === 'value'" [ngStyle]="calcTextTransformStyle(column)" class="value cell-content">
              <label for="chktablecomp-{{uid}}-{{i}}">
                <ng-container *ngIf="isValueDate(item[column.key])">
                  {{valueAsDate(item[column.key]) | shortDate : 'hideTime' }}
                </ng-container>
                <!-- TODO usar pipe -->
                <ng-container *ngIf="!isValueDate(item[column.key])">
                  @if (!item[column.key]) {
                    <span>'--'</span>
                  } @else {
                    <span [innerHTML]="(item[column.key]!.toString() | highlightWord: searchTerm())"></span>
                  }
                </ng-container>
              </label>
            </div>

            <div *ngIf="column.type === 'multiple-values' " [ngStyle]="calcTextTransformStyle(column)"
              class="value cell-content multiple">
              <span *ngFor="let value of ( item[column.key] | asMultValues )">
                <!-- TODO usar pipe -->
                <ng-container>
                  {{value}}
                </ng-container>
              </span>
            </div>

            <div *ngIf="column.type === 'check'" class="input-radio-check cell-content">
              <input type="checkbox" (change)="_checked(item , item[column.key] , column , i)"
                [checked]="item[column.key]" [(ngModel)]="item[column.key]" [name]="'checkgroup-' + i" [disabled]="!!item['disabled']"
                id="chktablecomp-{{uid}}-{{i}}">
            </div>

            <div *ngIf="column.type === 'radio'" class="input-radio-check cell-content">
              <input type="radio" (click)="_radioSelected(item)" [checked]="item[column.key]" [name]="setName(item, i)">
              <label>{{getInputLabel(item, column)}}</label>
            </div>

            <div *ngIf="column.type === 'btns'" class="btn-group cell-content">
              <ng-container *ngFor="let btn of (item[column.key] | asTableBtns)">
                <button [disabled]="btn.disabled || disableAllBtns"
                  class="row-action action {{typeToCssClassMap[btn.type]}}">
                  <mat-icon *ngIf="!(hideBtnsOnDisabled && (btn.disabled || disableAllBtns))"
                    class="btn--row btn {{typeToIconMap[btn.type]}}" [class.disabled]="btn.disabled || disableAllBtns"
                    (click)="_rowAction(item , btn)">
                    {{typeToIconMap[btn.type]}}
                  </mat-icon>
                  <div class="icon-background"></div>
                </button>
              </ng-container>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="emptyspace"></div>
</div>
